var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isFaqShowed)?_c('div',{staticClass:"faq"},[_c('div',{staticClass:"section-decor"}),_c('div',{staticClass:"faq__wrap"},[_c('FaqDumb',{attrs:{"title":"FAQ","questionAnswersList":_vm.question_answers_list}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }